import React from 'react';
import MyAutocomplete from '../../common/inputfields/MyAutocomplete';

export function BalancePartnerSelector({ getOptions, onChange}){
    return(
        <MyAutocomplete
            getOptions={getOptions}
            onChange={onChange}
            label={'Partner'}
            size='small'
        />
    )
}